document.addEventListener('DOMContentLoaded', () => {
  const thumbnails = document.querySelectorAll('.cm-thumbnail');
  const popup = document.getElementById('cm-video-popup');
  const popupVideo = document.getElementById('cm-popup-video');
  const closeBtn = popup.querySelector('.cm-close');

  // FIX: flyt popuppen til <body>, så "position: fixed" altid er viewport-fixed
  // (Shopify themes bruger ofte transform på wrappers, som ellers "fanger" fixed)
  if (popup && popup.parentElement !== document.body) {
    document.body.appendChild(popup);
  }

  const openPopup = (src) => {
    if (!src) return;

    popupVideo.src = src;
    popup.setAttribute('aria-hidden', 'false');

    // Lås scroll bagved
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    popupVideo.play().catch(() => {});
  };

  const closePopup = () => {
    popup.setAttribute('aria-hidden', 'true');

    // Genskab scroll
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';

    popupVideo.pause();
    popupVideo.removeAttribute('src');
    popupVideo.load();
  };

  thumbnails.forEach(thumbnail => {
    thumbnail.addEventListener('click', () => {
      const src = thumbnail.getAttribute('data-video');
      openPopup(src);
    });
  });

  closeBtn.addEventListener('click', closePopup);

  // Klik på overlay (udenfor video) lukker
  popup.addEventListener('click', (e) => {
    if (e.target === popup) closePopup();
  });

  // ESC lukker
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && popup.getAttribute('aria-hidden') === 'false') {
      closePopup();
    }
  });
});